import { getAuth, onAuthStateChanged } from "firebase/auth";
import { collection, doc, getDoc, getDocs } from "firebase/firestore";
import React, { useEffect, useState } from 'react';
import { HiChevronDoubleLeft, HiChevronDoubleRight, HiChevronLeft, HiChevronRight } from "react-icons/hi";
import { useNavigate } from 'react-router-dom';
import LoadingSpinner from '../assets/LoadingSpinner';
import '../css/InventoryIngredients.css';
import { db } from "../firebase-config";

const InventoryIngredients = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [ingredients, setIngredients] = useState([]);
  const [filteredIngredients, setFilteredIngredients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [usertype, setUsertype] = useState('');

   // Pagination state
   const [currentPage, setCurrentPage] = useState(1);
   const itemsPerPage = 20; // Adjust this value for more/less items per page

  const handleSearchChange = (e) => {
    const searchTerm = e.target.value;
    setSearch(searchTerm);

     // Reset current page when searching
     setCurrentPage(1);

    // Filter ingredients based on search term
    if (searchTerm.trim() === '') {
      setFilteredIngredients(ingredients); // If search is empty, show all ingredients
    } else {
      const filtered = ingredients.filter(ingredient =>
        ingredient.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredIngredients(filtered);
    }
    setCurrentPage(1); // Reset to first page on new search
  };

  const handleSearchClick = () => {
    console.log('Searching for:', search);
  };

  const handleEditClick = (id) => {
    console.log('Editing ingredient with ID:', id);
    navigate(`/pages/EditIngredient/${id}`);
  };

  const handleAddIngredientClick = () => {
    navigate('/pages/AddNewIngredient');
  };

  useEffect(() => {
    const getIngredients = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'ingredients'));
        const ingredientsArray = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        ingredientsArray.sort((a, b) => a.name.localeCompare(b.name));
        setIngredients(ingredientsArray);
        setFilteredIngredients(ingredientsArray); // Initialize filteredIngredients with all ingredients
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch ingredients. Please try again later.');
        console.error('Error fetching ingredients:', err);
        setLoading(false);
      }
    };
    getIngredients();
  }, []);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // Query the users collection to get the user type
        const userDocRef = doc(db, 'users', user.uid);
        const userDoc = await getDoc(userDocRef);
        if (userDoc.exists()) {
          const userData = userDoc.data();
          setUsertype(userData.usertype);  // Set usertype based on the Firestore document
        }
      }
    });

    return () => unsubscribe();
  }, []);

    // Calculate paginated data
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredIngredients.slice(indexOfFirstItem, indexOfLastItem);
  
    // Total pages
    const totalPages = Math.ceil(filteredIngredients.length / itemsPerPage);
  
    const handlePageChange = (newPage) => {
      if (newPage >= 1 && newPage <= totalPages) {
        setCurrentPage(newPage);
      }
    };

  if (loading) return <LoadingSpinner isVisible={true} />;
  if (error) return <div>Error: {error}</div>;

  return (
    <>
      <div className="header-ingredients">
        <h1 className="header-ingredients">Ingredients List</h1>
      </div>

      {/* Main content container */}
      <div className="container-ingredients">
        <div className="top-section-ingredients">
          <div className="search-container-ingredients">
            <input 
              type="text" 
              placeholder="Search ingredients..." 
              value={search}
              onChange={handleSearchChange}
              className="search-box-ingredients"
            />
          </div>
          <button onClick={handleAddIngredientClick} className="add-btn-ingredients" disabled={!(usertype === "Admin")}>Add Ingredient</button>
        </div>

        <table className="ingredient-table">
          <thead>
            <tr>
              <th>Item Name</th>
              <th>Quantity</th>
              <th>Unit of Measurement</th>
              <th>Dealer's Price</th>
              <th>Seller's Price</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map(ingredient => (
              <tr key={ingredient.id}>
                <td>{ingredient.name}</td>
                <td>{parseFloat(ingredient.quantity).toFixed(2)}</td>
                <td>{ingredient.measurement}</td>
                <td>₱{parseFloat(ingredient.dealerPrice).toFixed(2)}</td>
                <td>₱{parseFloat(ingredient.sellerPrice).toFixed(2)}</td>

                <td><button onClick={() => handleEditClick(ingredient.id)} className="edit-btn-ingredients" disabled={!(usertype === "Admin" || usertype === "Manager")}>Edit</button></td>

              </tr>
            ))}
          </tbody>
        </table>

                  {/* Pagination Controls */}
          <div className="pagination-controls">
            <button className="paginationButton"
              onClick={() => handlePageChange(1)} 
              disabled={currentPage === 1}
            >
              <HiChevronDoubleLeft />
            </button>
            <button className="paginationButton"
              onClick={() => handlePageChange(currentPage - 1)} 
              disabled={currentPage === 1}
            >
              <HiChevronLeft />
            </button>
            <span>Page {currentPage} of {totalPages}</span>
            <button className="paginationButton"
              onClick={() => handlePageChange(currentPage + 1)} 
              disabled={currentPage === totalPages}
            >
              <HiChevronRight />
            </button>
            <button className="paginationButton"
              onClick={() => handlePageChange(totalPages)} 
              disabled={currentPage === totalPages}
            >
              <HiChevronDoubleRight />
            </button>
          </div>
      </div>
    </>
  );
};

export default InventoryIngredients;